import { UALContext } from '@hivebp/ual-renderer'
import { useContext } from 'react'

export const useUAL = () => useContext(UALContext)
